@let files = fileSourcesWithSensitiveData();
@let urls = urlSourcesWithSensitiveData();

<div class="activity-sources__icons-container">
  @if (urls.length > 0) {
    <lucide-icon name="globe" [size]="12" />
    <div>{{ urls.length }}</div>
    <div class="activity-sources__separator"></div>
  }
  @if (files.length > 0) {
    <lucide-icon name="file" [size]="12" />
    <div>{{ files.length }}</div>
  }

  <lucide-icon
    [name]="expandSources() ? 'chevron-up' : 'chevron-down'"
    [size]="12"
    (click)="$event.stopPropagation(); expandSources.set(!expandSources())"
    class="activity-sources__expand-icon"
  />
</div>

<div class="activity-sources__content">
  @if (expandSources()) {
    @if (urls.length > 0) {
      <div class="activity-sources__title">URLs</div>
      @for (source of urls; track source.id) {
        <div
          [pTooltip]="pTooltipContent"
          [tooltipPosition]="'bottom'"
          [autoHide]="false"
          tooltipStyleClass="activity-sources__tooltip"
          class="activity-sources__name"
        >
          {{ source.link ? source.link : source.fileName }}
          {{ source.link ? source.link : source.fileName }}
        </div>
        <ng-template #pTooltipContent>
          @if (source.sensitiveData.hasSensitiveData) {
            <app-sensitive-message-content [id]="id()" [sensitiveDataParams]="source.sensitiveData" />
          }
          <div class="activity-sources__tooltip-text" [class.sensitive]="source.sensitiveData.hasSensitiveData">
            {{ source.link ? source.link : source.fileName }}
          </div>
        </ng-template>
      }
    }
    @if (files.length > 0) {
      <div class="activity-sources__title">Files</div>
      @for (source of files; track source.id) {
        <div
          [pTooltip]="source.sensitiveData.hasSensitiveData ? pTooltipContent : undefined"
          [tooltipPosition]="'bottom'"
          [autoHide]="false"
          tooltipStyleClass="activity-sources__tooltip"
          class="activity-sources__name"
        >
          {{ source.fileName }}
        </div>
        <ng-template #pTooltipContent>
          <app-sensitive-message-content
            [id]="id()"
            [sensitiveDataParams]="source.sensitiveData"
            (sensitiveDataLoaded)="source.sensitiveData.hasSensitiveData = $event.length > 0"
          />
          <app-sensitive-message-content
            [id]="id()"
            [sensitiveDataParams]="source.sensitiveData"
            (sensitiveDataLoaded)="source.sensitiveData.hasSensitiveData = $event.length > 0"
          />
        </ng-template>
      }
    }
  }
</div>
